import { render, staticRenderFns } from "./TransportProject.vue?vue&type=template&id=202883f2&"
import script from "./TransportProject.vue?vue&type=script&lang=js&"
export * from "./TransportProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports